import { useEffect, useState } from "react";
import { useSeriesShowContext } from "./SeriesShowApp";

const QUOTE_DELAY_MS = 500;
const QUOTE_FAILED = "Couldn't preview the fees. Check the price and try again.";

const usePassQuote = ({ enabled, price, roundUp, taxIds }) => {
  const { handleQuotePassProduct } = useSeriesShowContext();
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState(null);
  const taxKey = taxIds.join(",");

  useEffect(() => {
    if (!enabled || !(Number(price) > 0)) {
      setQuote(null);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const data = await handleQuotePassProduct({
          price,
          round_up: roundUp,
          taxable_items_attributes: taxIds.map((id) => ({ manual_tax_id: id })),
        });
        if (cancelled) return;
        setQuote({ ...data, price, round_up: roundUp });
        setError(null);
      } catch (e) {
        if (cancelled) return;
        setQuote(null);
        setError(e?.response?.data?.errors?.[0] || QUOTE_FAILED);
      }
    }, QUOTE_DELAY_MS);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [enabled, price, roundUp, taxKey]);

  return { quote, error };
};

export default usePassQuote;
